<template>
  <div class="stats-summary-row d-a-c lh30 ww100 pt16">
    <div class="pt30 tc" style="width: 80px;">
      <p class="gray9">今日</p>
      <p class="gray9">昨日</p>
    </div>
    <div class="flex-1 tc">
      <p>成交额</p>
      <p class="f20 fb gray3">{{dataModel.order.orderTotalPriceT}}</p>
      <p class="gray">{{dataModel.order.orderTotalPriceY}}</p>
    </div>
    <div class="flex-1 tc">
      <p>客单价</p>
      <p class="f20 fb gray3">{{dataModel.order.orderPerPriceT}}</p>
      <p class="gray">{{dataModel.order.orderPerPriceY}}</p>
    </div>
    <div class="flex-1 tc">
      <p>付款订单</p>
      <p class="f20 fb gray3">{{dataModel.order.orderTotalT}}</p>
      <p class="gray">{{dataModel.order.orderTotalY}}</p>
    </div>
    <div class="flex-1 tc">
      <p>付款人数</p>
      <p class="f20 fb gray3">{{dataModel.order.orderUserTotalT}}</p>
      <p class="gray">{{dataModel.order.orderUserTotalY}}</p>
    </div>
    <div class="flex-1 tc">
      <p>成功退款金额</p>
      <p class="f20 fb gray3">{{dataModel.order.orderRefundMoneyT}}</p>
      <p class="gray">{{dataModel.order.orderRefundMoneyY}}</p>
    </div>
    <div class="flex-1 tc">
      <p>退款订单</p>
      <p class="f20 fb gray3">{{dataModel.order.orderRefundTotalT}}</p>
      <p class="gray">{{dataModel.order.orderRefundTotalY}}</p>
    </div>
  </div>
</template>
<script>

export default {
  components:{
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,

    };
  },
  inject: ['dataModel'],
  created() {

  },
  methods: {


  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 992px) {
  .stats-summary-row {
    flex-wrap: wrap;
    align-items: flex-start;
    padding-top: 8px;

    > .pt30 {
      width: 100%;
      padding-top: 0 !important;
      display: flex;
      justify-content: space-around;
      margin-bottom: 8px;
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }

    .flex-1 {
      flex: 0 0 33.33%;
      min-width: 0;
      padding: 8px 4px;
      box-sizing: border-box;
      margin-bottom: 4px;
    }

    .f20 {
      font-size: 16px !important;
      word-break: break-all;
    }
  }
}

@media (max-width: 480px) {
  .stats-summary-row .flex-1 {
    flex: 0 0 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/Total.vue